import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import router from '@/router';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    appTitle: 'TEXTCHECKER',
    user: null,
    error: null,
    loading: false,
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload;
    },
    setError (state, payload) {
      state.error = payload;
    },
    setLoading (state, payload) {
      state.loading = payload;
    }
  },
  actions: {
    userSignUp ({commit}, payload) {
      commit('setLoading', true);
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
        commit('setUser', {email: firebaseUser.user.email});
        commit('setLoading', false);
        router.push('/editor');
      })
      .catch(error => {
        commit('setError', error.message);
        commit('setLoading', false);
      })
    },
    userSignIn ({commit}, payload) {
      commit('setLoading', true);
      firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
        commit('setUser', {email: firebaseUser.user.email});
        commit('setLoading', false);
        commit('setError', null);
        router.push('/editor');
      })
      .catch(error => {
        commit('setError', error.message);
        commit('setLoading', false);
      })
    },
    googleLogin({commit}) {
      firebase
      .auth()
      .signInWithRedirect(new firebase.auth.GoogleAuthProvider());
      router.push('/editor');
    },
    autoSignIn({commit}, payload) {
      commit('setUser', {email: payload.email});
    },
    userSignOut({commit}) {
      firebase.auth().signOut();
      commit('setUser', null);
      router.push('/');
    }
  },
  getters:{
    isAuthenticated (state) {
      return state.user !== null && state.user !== undefined;
    }
  },
});


// WEBPACK FOOTER //
// ./src/store/index.js